// extracted by mini-css-extract-plugin
module.exports = {"root":"PersonalDetailsPage_root__1dxyK"};